<template>
  <div class="container">
    <!-- GPS Error Modal -->
    <template v-if="gpsErrorModal === true">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header bg-warning">
                  <h5 class="modal-title">
                    Unable to acces your device location
                  </h5>
                </div>
                <div class="modal-body">
                  <p>
                    Your privacy and/or location settings are preventing this
                    page from getting your location.
                  </p>
                  <p>
                    You can still enter your zip code, county, or city into the
                    search box for results near you.
                  </p>
                </div>
                <div class="modal-footer">
                  <span
                    type="button"
                    class="btn btn-secondary"
                    v-on:click="gpsErrorModal = false"
                    >Ok</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
        <button
          v-bind:class="[unableToLocate ? 'btn disabled' : 'btn']"
          id="findme"
          v-on:click.prevent="golocateme"
          v-if="this.canGeolocate === true"
        >
          <div
            v-if="geoButtonText == 'Locating…'"
            class="spinner-border spinner-border-sm text-light"
            role="status"
          ></div>

          {{ this.geoButtonText }}
        </button>
      </div>

      <div
        id="geolocateOr"
        class="col-md-0 d-none d-lg-block"
        v-if="this.canGeolocate === true"
      >
        <em>or</em>
      </div>

      <div class="col col-md-4">
        <div id="searchboxWrapper">
          
          <v-select
            v-model="selectedResult"
            placeholder="Search by zip, city or county"
            label="l"
            :options="this.rootStore.searchData"
          >
          </v-select>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import { useRootStore } from "../store";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
 import { toRaw } from "vue";

export default {
  name: "SearchBox",
  components: {
    vSelect,
  },
  data() {
    return {
      rootStore: useRootStore(),
      canGeolocate: false,
      gpsErrorModal: false,
      unableToLocate: false,
      geoResult: [],
      selectedResult: [],
      geoButtonText: "Use my location",
    };
  },
  watch: {
    geoResult: function () {
      if (typeof this.geoResult === "object") {
        this.rootStore.SET_USER_LOCATION(this.geoResult);
      }
    },
    getUserLocation: function () {
      // Sets the County Param in Search field
      const userLocation = toRaw(this.getUserLocation);
      const countySelected = userLocation?.County;
      const searchData = this.rootStore.searchData
      const finalObject = searchData.find(item => (item?.f === "county" && item?.l?.toUpperCase() === (`${countySelected} County`).toUpperCase()))
      if (finalObject) {
        this.selectedResult = finalObject;
      }
      // Sets the County Param in url
      const url = new URL(window.location.href);
      const currentCounty = url.searchParams.get('county')
      if (finalObject && finalObject.l && finalObject.a && finalObject.o) {
        const filteredCounty = finalObject.l.replace(" County", "")
        if (currentCounty !== filteredCounty) {
          url.searchParams.set('county', filteredCounty);
          history.pushState({}, '', url.href)
        }
      } else {
        url.searchParams.delete('county');
        history.pushState({}, '', url.href)
      }

    },
    selectedResult: function () {


      if (this.selectedResult !== undefined && this.selectedResult !== null && typeof this.selectedResult === "object") {
        var _userCoords = {};

        _userCoords.Lat = this.selectedResult.a;
        _userCoords.Long = this.selectedResult.o;

        if (this.selectedResult.f === "county") {
          _userCoords.County = this.selectedResult.l.replace(" County", "");
        }

        if (this.selectedResult.f === "city") {
          _userCoords.City = this.selectedResult.l;
        }


        this.rootStore.SET_USER_LOCATION(_userCoords);
      }
    },
  },
  methods: {
  // User may have indicated a location preference. 
    // Check if it is set and apply it on load.
    getSiteCookies(){
        if(document.cookie.search('ncdot-gov-zip-lat') !== -1 && document.cookie.search('ncdot-gov-zip-long') !== -1){
        const cookieLat = document.cookie
            .split('; ')
            .find(row => row.startsWith('ncdot-gov-zip-lat='))
            .split('=')[1];
        const cookieLong = document.cookie
            .split('; ')
            .find(row => row.startsWith('ncdot-gov-zip-long='))
            .split('=')[1];


          console.log('Use users existing location of ' + cookieLat + ' and ' + cookieLong)

          // Add check for any user who had a location and cleared it out,
          // which leaves the cookies in an odd place of existing but not
          // having any values
          if(cookieLat !=='' && cookieLong !==''){
            const getUserSiteLoc = {}

            getUserSiteLoc.Lat = cookieLat;
            getUserSiteLoc.Long = cookieLong;

            this.geoResult = getUserSiteLoc;
          }

    }

    },


    golocatemeError: function () {
      var thisGoLocateme = this;
      thisGoLocateme.geoButtonText = "Unable to access location";
      thisGoLocateme.gpsErrorModal = true;
      thisGoLocateme.unableToLocate = true;
      console.log("GPS ERROR");
    },

    golocatemeSuccess: function (position) {
      var thisGoLocateme = this;

      var _geoCordResult = {};

      _geoCordResult.Lat = position.coords.latitude;
      _geoCordResult.Long = position.coords.longitude;

      thisGoLocateme.geoResult = _geoCordResult;

      thisGoLocateme.geoButtonText = "Located!";
      console.log("geolocating end");
    },
    golocateme: function () {
      var thisGoLocateme = this;

      if (!navigator.geolocation) {
        // thisGoLocateme.errorModal = true;
      } else {
        thisGoLocateme.geoButtonText = "Locating…";
        console.log("Geolocating start");
        navigator.geolocation.getCurrentPosition(
          thisGoLocateme.golocatemeSuccess,
          thisGoLocateme.golocatemeError
        );
      }
    },
  },
  computed: {
    getUserLocation() {
      return this.rootStore.userLocation;
  },
  },
  mounted() {
    // Shows geolocate button if we can geolocate
    if (!navigator.geolocation) {
      console.log("No geolocation available");
      this.canGeolocate = false;
    } else {
      this.canGeolocate = true;
    }
  
    
    this.getSiteCookies()
  },
};
</script>